import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ambzy6ccke: FaireBrandEntity = {
  token: "b_ambzy6ccke",
  type: "brand",
  name: "Night Blooms Goods",
  avatarUrl:
    "https://cdn.faire.com/fastly/2e9050072929fd0cf7fb26e36c5549360abb4cc353c8e3585b40b688901b8223.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4f096327eef91e7eb217fa2be60c6711722019546e01559410f6178493634eb2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2e9050072929fd0cf7fb26e36c5549360abb4cc353c8e3585b40b688901b8223.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4f096327eef91e7eb217fa2be60c6711722019546e01559410f6178493634eb2.jpeg",
  location: "Ojai, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 15,
  isInsider: true,
  description:
    "Night Blooms is a lifestyle and sensory experience brand created by a husband and wife team based in Ojai. We make non-toxic handcrafted scented illuminates and goods designed to bridge dimensions of the natural and mystical worlds. As a 1% For the Planet company, we are focused on sourcing non-toxic and natural materials that support the wellbeing of all beings on our planet. \n",
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:23:57.196Z",
    importedBy: "entity-db-cli",
  },
};
